import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { enqueueSnackbar } from '@applift/factor'

import { getPostbackCreationInfoQueryKey } from '../api/queryKey'
import { WithResponse } from '../models/Response'
import {
  createPostbackConversion,
  editPostbackConversion,
  getMeasurementPartners,
} from '../api/postback'
import { queryClient } from '../cache'
import { ConversionCount } from '../models/Conversion'

type useListFilterProps = Pick<UseQueryOptions, 'enabled' | 'onSuccess'>

export const useMeasurementPartnersList = (props?: useListFilterProps) => {
  const data = useQuery(
    getPostbackCreationInfoQueryKey.keys({
      scope: 'getMeasurementPartners',
    }),
    getMeasurementPartners,
    {
      enabled: props?.enabled,
      onError: (e: WithResponse) => {
        enqueueSnackbar(
          e.errorObjects
            ? (e.errorObjects[0]?.error as string)
            : 'Something went wrong!',
          {
            variant: 'error',
          }
        )
      },
      keepPreviousData: true,
    }
  )
  return data.data?.data
}

const typeMapper = {
  all: '',
  postback: '2',
}

export const useCreatePostback = (conversionType: string) => {
  const mutationResult = useMutation(createPostbackConversion, {
    mutationKey: ['createPostback'],
    onSuccess: () => {
      queryClient.refetchQueries({
        predicate: query => {
          return (
            //@ts-ignore
            query.queryKey?.[0]?.scope === 'getConversionList' &&
            //@ts-ignore
            query.queryKey?.[0]?.typeIds === typeMapper[conversionType]
          )
        },
      })
      queryClient.setQueriesData(
        {
          predicate: (query: any) =>
            query.queryKey?.[0]?.scope === 'getConversionsCount',
        },
        (conversionCount: ConversionCount | undefined) => ({
          PIXEL: conversionCount?.PIXEL ?? 0,
          POSTBACK: (conversionCount?.POSTBACK ?? 0) + 1,
          ALL: (conversionCount?.ALL ?? 0) + 1,
        })
      )
    },
    onError: (e: any) => {
      enqueueSnackbar(
        e.errorObjects
          ? (e.errorObjects[0]?.error as string)
          : 'Something went wrong. Please try after sometime.',
        {
          variant: 'error',
        }
      )
    },
  })

  return mutationResult
}

export const useEditPostback = (conversionType: string) => {
  const mutationResult = useMutation(editPostbackConversion, {
    mutationKey: ['editPostback'],
    onSuccess: () => {
      queryClient.refetchQueries({
        predicate: query => {
          return (
            //@ts-ignore
            query.queryKey?.[0]?.scope === 'getConversionList' &&
            //@ts-ignore
            query.queryKey?.[0]?.typeIds === typeMapper[conversionType]
          )
        },
      })
    },
    onError: (e: any) => {
      enqueueSnackbar(
        e.errorObjects
          ? (e.errorObjects[0]?.error as string)
          : 'Something went wrong. Please try after sometime.',
        {
          variant: 'error',
        }
      )
    },
  })
  return mutationResult
}
